module.exports = __webpack_public_path__ + "69e08d6367cff69e5752ffe45102d46c.png";


//////////////////
// WEBPACK FOOTER
// ./work/lebonchoix/img/one.png
// module id = 741
// module chunks = 0